import Modal from "components/Modal";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useModal from "hooks/useModal";
import OrderRes from "../../../types/res/order/OrderRes";
import { Link } from "react-router-dom";
type Props = {
  setStateOrders: any;
  orders: OrderRes[];
};
const CastScheduleOnItemMoveChangeClass: React.FC<Props> = ({
  setStateOrders,
  orders,
}) => {
  const { t } = useTranslation("castSchedule");
  const [
    castScheduleOnItemMoveChangeClassModal,
    setCastScheduleOnItemMoveChangeClassShow,
  ] = useModal("castScheduleOnItemMoveChangeClass");
  const [orderId, setOrderId] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!castScheduleOnItemMoveChangeClassModal.meta?.order) return;
    setOrderId(castScheduleOnItemMoveChangeClassModal.meta.order.orderId);
  }, [castScheduleOnItemMoveChangeClassModal.meta?.order]);
  useEffect(() => {
    if (castScheduleOnItemMoveChangeClassModal.show) return;
    setStateOrders(orders);
  }, [castScheduleOnItemMoveChangeClassModal?.show]);
  return (
    <Modal
      show={castScheduleOnItemMoveChangeClassModal.show}
      setShow={setCastScheduleOnItemMoveChangeClassShow}
      title={t("orderTitle.change", {
        name: castScheduleOnItemMoveChangeClassModal.meta?.castName?.name,
      })}
    >
      <Container>
        <Box display="flex" justifyContent="center">
          <Box display="flex" flexDirection="column">
            <Typography style={{ margin: "10px 0" }}>
              {t("changeClassDialog.moveToEdit")}
            </Typography>
            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                color="default"
                disabled={loading}
                onClick={() => setCastScheduleOnItemMoveChangeClassShow(false)}
                style={{ marginRight: "10px" }}
              >
                {loading ? (
                  <CircularProgress color="inherit" size={24} />
                ) : (
                  t("common.no")
                )}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={loading}
                component={Link}
                to={`/order/${orderId}`}
              >
                {loading ? (
                  <CircularProgress color="inherit" size={24} />
                ) : (
                  t("common.yes")
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Modal>
  );
};
export default CastScheduleOnItemMoveChangeClass;
